import { render, staticRenderFns } from "./oldData.vue?vue&type=template&id=214a5a9c&"
import script from "./oldData.vue?vue&type=script&lang=js&"
export * from "./oldData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports